// extracted by mini-css-extract-plugin
module.exports = {"vInk":"#131313","item":"Item__item___mhZ1v"};